import { Directive, OnDestroy } from '@angular/core';
import { SubscriptionBasedComponent } from './subscription-based.component';
import { BehaviorSubject } from 'rxjs';

@Directive()
export class AsyncChildRenderComponent extends SubscriptionBasedComponent
  implements OnDestroy {
  public renderChildren: BehaviorSubject<boolean>;

  constructor() {
    super();
    this.renderChildren = new BehaviorSubject(false);
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.renderChildren.complete();
    this.renderChildren = null;
  }
}
